import { Component } from 'solid-js'
import GenerateImageOptionButton from './GenerateImageOptionButton'

const GenerateImageAccessoriesOptions: Component<{
  updatePrompt: (value: string, replacePrompt: boolean) => void
  currentPrompt: string
}> = (props) => {
  return (
    <div class="flex flex-row flex-wrap gap-3">
      <GenerateImageOptionButton
        title="Necklace"
        value="wearing a necklace"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing a necklace')}
      />
      <GenerateImageOptionButton
        title="Earrings"
        value="wearing earrings"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing earrings')}
      />
      <GenerateImageOptionButton
        title="Tattoos"
        value="tattoos on the body"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('tattoos on the body')}
      />
      <GenerateImageOptionButton
        title="Glasses"
        value=" wearing stylish glasses"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes(' wearing stylish glasses')}
      />
      <GenerateImageOptionButton
        title="Candles"
        value="a room lit with aromatic candles"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('a room lit with aromatic candles')}
      />
      <GenerateImageOptionButton
        title="Scarf"
        value="wearing a colorful scarf"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing a colorful scarf')}
      />
      <GenerateImageOptionButton
        title="Baseball cap"
        value="wearing a baseball cap outdoors"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('wearing a baseball cap outdoors')}
      />
    </div>
  )
}

export default GenerateImageAccessoriesOptions
